var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkdin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 5.33325C11.7274 5.33325 12.7448 5.75468 13.4949 6.50482C14.2451 7.25497 14.6665 8.27239 14.6665 9.33325V13.9999H11.9998V9.33325C11.9998 8.97963 11.8594 8.64049 11.6093 8.39044C11.3593 8.14039 11.0201 7.99992 10.6665 7.99992C10.3129 7.99992 9.97374 8.14039 9.7237 8.39044C9.47365 8.64049 9.33317 8.97963 9.33317 9.33325V13.9999H6.6665V9.33325C6.6665 8.27239 7.08793 7.25497 7.83808 6.50482C8.58822 5.75468 9.60564 5.33325 10.6665 5.33325Z",
    stroke: "#99A1AF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00016 6H1.3335V14H4.00016V6Z",
    stroke: "#99A1AF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66683 3.99992C3.40321 3.99992 4.00016 3.40297 4.00016 2.66659C4.00016 1.93021 3.40321 1.33325 2.66683 1.33325C1.93045 1.33325 1.3335 1.93021 1.3335 2.66659C1.3335 3.40297 1.93045 3.99992 2.66683 3.99992Z",
    stroke: "#99A1AF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/linkdin.375931e52a7becd50508f4a0ac07aed6.svg";
export { ForwardRef as ReactComponent };